import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { modelPreviewText, SystemModel } from '../../templates/catalog';
import { SystemModelStatus } from '../../templates/modelStatus';
import { ChannelIndicator } from './ChannelIndicator';
import { ModelStatusBadge } from './ModelStatusBadge';

type SystemModelRowProps = {
  model: SystemModel;
  status?: SystemModelStatus;
  statusSkeleton?: boolean;
  onPreview: (model: SystemModel) => void;
  onCustomize: (model: SystemModel) => void;
};

export const SystemModelRow: FC<SystemModelRowProps> = ({ model, status, statusSkeleton, onPreview, onCustomize }) => {
  const { t } = useTranslation('comuni');
  const showStatus = model.channel === 'whatsapp';

  return (
    <li className='grid grid-cols-[minmax(0,1.2fr)_auto_minmax(0,2fr)_minmax(7rem,auto)_auto] items-center gap-3 px-4 py-3 max-md:grid-cols-1 max-md:gap-2'>
      <span className='truncate font-semibold'>{model.name}</span>
      <ChannelIndicator channel={model.channel} />
      <p className='truncate text-sm text-tertiary-600'>{modelPreviewText(model)}</p>
      <div className='min-h-5'>{showStatus ? <ModelStatusBadge status={status} skeleton={statusSkeleton} /> : null}</div>
      <div className='flex flex-none items-center gap-3'>
        <button type='button' onClick={() => onPreview(model)} className='text-sm font-semibold text-brand-700 hover:text-brand-800'>
          {t('modelli.preview')}
        </button>
        <button type='button' onClick={() => onCustomize(model)} className='text-sm font-semibold text-brand-700 hover:text-brand-800'>
          {t('modelli.customize')}
        </button>
      </div>
    </li>
  );
};
